<template>
  <party-template :type="3"/>
</template>

<script>
import PartyTemplate from '@/views/basedata/parties/PartyTemplate.vue'

export default {
  name: 'CustomerBaseData',
  components: { PartyTemplate }
}
</script>